<template>
  <div style="zoom:0.9;">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("aggregator", 1) }}
      </div>
      <router-link class="btn-blue" to="/user-management/aggregator-users">{{ $tc("aggregator", 1) }} {{ $tc("user", 2)
        }}
        {{ $tc("list", 2) }}</router-link>
    </div>

    <div class="white-wrapper">
      <form class="row">
        <section v-if="true" class="mb-4 w-100 px-3 section-new">
          <div class="section-title mb-3 d-flex justify-content-between section-collapse-box new-border"
            style="padding: 6px; align-items: center; border-radius: 10px" v-b-toggle.personalDetails>
            <span class="fs">
              {{ $tc("Personal Details", 2) }}
            </span>
            <button type="button" class="btn-transparent chevron">
              <img src="@/assets/img/icons/primary/chevron-down.svg" height="24" width="24" />
            </button>
          </div>
          <b-collapse id="personalDetails" class="mt-2" v-model="sectionCollapse.personalDetails">
            <div class="row pr-2 pl-2 pt-3 pb-2 new-border br-10 mx-auto back" style="border-radius: 10px">
              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input placeholder="." type="text" v-model="userDetails.first_name" name="firstname" id="firstname"
                      v-validate="'required|alpha_spaces'" />
                    <label>{{ $t("name") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_NameTooltip')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('firstname')">{{
                    errors.first("firstname")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input placeholder="." type="text" v-model="userDetails.middle_name" />
                    <label>{{ $t("middlename") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_MiddleName')" /> -->
                </div>
                <!-- <p
            v-if="submitted && errors.has('middlename')"
            class="error_message"
          >{{ errors.first('middlename') }}</p>-->
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input placeholder="." v-model="userDetails.last_name" type="text" name="lastname" id="lastname"
                      v-validate="'required|alpha_spaces'" />
                    <label>{{ $t("lastname") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_LastName')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('lastname')">{{
                    errors.first("lastname")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input placeholder="." v-model="userDetails.up_address1" type="text" name="address" id="address"
                      v-validate="'required'" />
                    <!-- v-validate="'required|regex: /^[_]*$/|alpha_dash|alpha_num|alpha_spaces'" -->
                    <label>{{ $t("address") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_Address')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('address')">{{
                    errors.first("address")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <DropdownInputSearch label="Country" :dropdownitems="Countries" name="selectcountry"
                    id="selectcountry" placeholder="Search Country" type="country" object_value="country_name"
                    :onHandler="onSelectHandler" :selectedText="selected.Country" />
                  <!-- <Tooltip :title="$t('user_Country')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <!-- <div class="dropdown-curve-container">
              <label
                :class="selected.State && selected.State.length > 0 ? 'shift-up' : '' "
              >{{ $t('select') }} {{ $tc('state', 1) }}</label>
              <b-dropdown :text="selected.State" variant="dropdown-curve" class="w-100">
                <div class="px-2 pb-2">
                      <input
                        required
                        autofocus
                        type="search"
                        placeholder="Search State"
                        class="form-control form-control-sm"
                        v-on:keyup="onSearchState($event.target.value)"
                        v-on:keydown="onSearchState($event.target.value)"
                        v-model="searchState"
                      />
                    </div>
                <b-dropdown-item
                  v-for="(state,stateIndex) in States"
                  :key="stateIndex"
                  @click="onSelectHandler('state',state)"
                  name="selectstate"
                  id="selectstate"
                >{{ state.state_name }}</b-dropdown-item>
              </b-dropdown>
            </div> -->
                  <DropdownInputSearch label="State" :dropdownitems="States" name="selectstate" id="selectstate"
                    placeholder="Search State" type="state" object_value="state_name" :onHandler="onSelectHandler"
                    :selectedText="selected.State" />
                  <!-- <Tooltip :title="$t('user_State')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <!-- <div class="dropdown-curve-container">
              <label
                :class="selected.City && selected.City.length > 0 ? 'shift-up' : '' "
              >{{ $t('select') }} {{ $tc('city', 1) }}</label>
              <b-dropdown :text="selected.City" variant="dropdown-curve" class="w-100">
                <div class="px-2 pb-2">
                      <input
                        required
                        autofocus
                        type="search"
                        placeholder="Search City"
                        class="form-control form-control-sm"
                        v-on:keyup="onSearchCity($event.target.value)"
                        v-on:keydown="onSearchCity($event.target.value)"
                        v-model="searchCity"
                      />
                    </div>
                <b-dropdown-item
                  v-for="(city,cityIndex) in Cities"
                  :key="cityIndex"
                  @click="onSelectHandler('city',city)"
                  name="selectcity"
                  id="selectcity"
                >{{ city.city_name }}</b-dropdown-item>
              </b-dropdown>
            </div> -->
                  <DropdownInputSearch label="City" :dropdownitems="Cities" name="selectcity" id="selectcity"
                    placeholder="Search City" type="city" object_value="city_name" :onHandler="onSelectHandler"
                    :selectedText="selected.City" />
                  <!-- <Tooltip :title="$t('user_Cities')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input placeholder="." v-model="userDetails.zipcode" type="text" name="zipcode" id="zipcode" />
                    <label>{{ $t("zipcode") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_ZipCode')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label :class="selected.AggregatorType &&
                        selected.AggregatorType.length > 0
                        ? 'shift-up'
                        : ''
                      ">{{ $tc("aggregator", 1) }} {{ $tc("type", 1) }}</label>
                    <b-dropdown :text="selected.AggregatorType" variant="dropdown-curve" class="w-100">
                      <b-dropdown-item v-for="(aggregator, aggregatorIndex) in aggregatorType" :key="aggregatorIndex"
                        @click="onSelectHandler('aggregatorType', aggregator)" name="selectstate" id="selectstate">{{
                        aggregator }}</b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!-- <Tooltip :title="$t('user_State')" /> -->
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input placeholder="." v-model="userDetails.email_id" type="email" name="a_email_id" id="a_email_id"
                      v-validate="'required|email'" />
                    <label>{{ $t("emailid") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_EmailId')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('a_email_id')">{{
                    errors.first("a_email_id")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input placeholder="." v-model="userDetails.up_alt_contact_no" type="text" name="phoneno"
                      id="phoneno" v-validate="'numeric|min:7'" />
                    <label>{{ $t("phone") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_phone')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('phoneno')">{{
                    errors.first("phoneno")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material row">
                    <div class="col-4">
                      <b-dropdown :text="userDetails.country_mob_code
                          ? userDetails.country_mob_code
                          : 'Code'
                        " variant="dropdown-curve" class="w-100 text-center mr-3" placeholder="code" name="countrycode"
                        id="countrycode">
                        <div class="px-2 pb-2">
                          <input required autofocus type="search" placeholder="Search Code"
                            class="form-control form-control-sm" v-on:keyup="onSearchCode($event.target.value)"
                            v-on:keydown="onSearchCode($event.target.value)"
                            v-on:search="onSearchCode($event.target.value)" v-model="searchCode" />
                        </div>
                        <b-dropdown-item href="#" v-for="(countrycode, countryIndex) in countryList" :key="countryIndex"
                          v-on:click="
                            onSelectHandler('countrycode', countrycode)
                            " v-if="countrycode.country_mob_code != null">{{ countrycode.country_mob_code
                          }}</b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <div class="col-8 pl-1">
                      <input placeholder="." v-model="userDetails.mobile_no" type="text" name="mobileno" id="monileno"
                        v-validate="'required|numeric|min:8|max:14'" />
                      <label>{{ $t("mobiles") }}</label>
                    </div>
                  </div>
                  <!-- <Tooltip :title="$t('user_mobile')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && !userDetails.country_mob_code">{{
                    "Country Code Required."
                  }}</span>
                  <span>{{ " " }}</span>
                  <span v-if="submitted && errors.has('mobileno')">{{
                    errors.first("mobileno")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input placeholder="." v-model="userDetails.username" v-validate="{
                      required: 'required',
                      regex: /^[a-zA-Z0-9-_@]+$/,
                    }" type="text" name="username" id="username" />
                    <!-- v-validate="'required|alpha_num'" -->
                    <label>{{ $t("username") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_Username')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('username')">{{
                    errors.first("username")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input placeholder="." v-model="userDetails.password" type="password" name="password" id="password"
                      v-validate="{
                        required: 'required',
                        regex:
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9!@#$%^&*]{6,}$/,
                      }" />
                    <!-- \([1-9][0-9]\)\s[9-9]\d{4}\-\d{4} -->
                    <!-- /[((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).{6,20})]/g -->
                    <!-- <br /> -->
                    <!-- {{userDetails.password}} -->
                    <!-- {required: true ,alpha_num: true, regex: /[a-zA-Z0-9!@#$]/g} -->
                    <label>{{ $t("password") }}</label>
                  </div>
                  <!-- <Tooltip :title="$t('user_Password')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('password')">{{
                    errors.first("password")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input placeholder="." v-model="userDetails.report_code" type="text" name="report_code"
                      id="report_code" />
                    <label>{{ "Report Code" }}</label>
                  </div>
                </div>
                <p class="error_message">
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input placeholder="." v-model="userDetails.gl_account" type="text" name="gl_account"
                      id="gl_account" />
                    <label>{{ "GL Account" }}</label>
                  </div>
                </div>
                <p class="error_message">
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input placeholder="." v-model="userDetails.gl_desc" type="text" name="gl_desc" id="gl_desc" />
                    <label>{{ "GL Description" }}</label>
                  </div>
                </div>
                <p class="error_message">
                </p>
              </div>

              <div class="col-2 align-self-center mb-3" v-if="showKitchenOrderFields">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input placeholder="." v-model="userDetails.kitchen_color_code" type="color"
                      name="kitchen_color_code" id="kitchen_color_code" />
                    <label>{{ "Color Code" }}</label>
                  </div>
                </div>
                <p class="error_message">
                </p>
              </div>

              <div class="col-2 align-self-center mb-3" v-if="showKitchenOrderFields">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input placeholder="." v-model="userDetails.kitchen_order_seq" type="number"
                      name="kitchen_order_seq" id="kitchen_order_seq" />
                    <label>{{ "Order Seq" }}</label>
                  </div>
                </div>
                <p class="error_message">
                </p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <label class="mb-0 mr-3">Is {{ $t("online_fee") }} applied</label>
                  <b-form-checkbox :unchecked-value="'N'" :value="'Y'"
                    v-model="userDetails.is_internet_handling_fee_applied" name="check-button-internethandling-fee"
                    switch class="j-checkbox mb-0 ml-2"></b-form-checkbox>
                </div>
                <p class="error_message"></p>
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <label class="mb-0 mr-3">Direct Payment Allowed</label>
                  <b-form-checkbox :unchecked-value="'N'" :value="'Y'" v-model="userDetails.is_direct_payment_allowed"
                    name="check-button-is-direct-payment-allowed" switch class="j-checkbox mb-0 ml-2"></b-form-checkbox>
                </div>
                <p class="error_message"></p>
              </div>
            </div>
          </b-collapse>
        </section>

        <div class="col-md-12 text-center mt-4">
          <button :disabled="btenable" @click.prevent.stop="onFinalSubmit(true)" class="btn-blue">
            {{ $t("save") }}
          </button>
          <button :disabled="btenable" @click.prevent.stop="onFinalSubmit(false)" class="btn-blue">
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="/user-management/aggregator-users">{{ $t("cancel")
            }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import UserService from "@/services/UserService";
import moment from "moment";
import { Role, CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

const selected = {
  Country: "",
  Gender: "",
  Departments: "",
  Cinemas: "",
  Role: "",
  State: "",
  City: "",
  Designation: "",
  Distributor: "",
  AggregatorType: "",
};

var state = {
  date: new Date(1990, 1, 1),
};

export default {
  data() {
    return {
      btenable: false,
      employeementType: ["Contract", "Permanent", "Probation"],
      aggregatorType: ["Website", "Third Party", "Kiosk", "App", "Fnb App"],
      loginRoleId: null,
      loginCinema_Id: null,
      messagegender: "Please Select Gender.",
      messagecountry: "Please Select Country.",
      messagestate: "Please Select State.",
      messagecity: "Please Select City.",
      messagerole: "Please Select Role.",
      messagedesignation: "Please Select Designation.",
      messagecinema: "Please Select Cinema.",
      messagedepartment: "Please Select Department.",
      messagedistributor: "Please Select Distributor.",
      errmsg: "",

      submitted: false,
      isRoleID: true,
      // cinema_id: "",
      customRegex: "//",
      userDetails: {
        username: "",
        user_profile_image_url: "",
        aggregator_type: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        email_id: "",
        country_mob_code: "",
        mobile_no: "",
        cinema_id: 0,
        role_id: 10,
        password: "",
        zipcode: "",
        userpin: "",
        passwordpin: "",
        report_code: "",
        gl_account: "",
        gl_desc: "",
        kitchen_order_seq: "",
        kitchen_color_code: "#0e4e91",
        //userprofileData
        up_employee_code: "",
        up_dob: new Date("1990-01-01"),
        up_doj: "",
        up_address1: "",
        up_alt_contact_no: "",
        // dropdown ids
        designation_id: null,
        gender_id: null,
        city_id: null,
        state_id: null,
        country_id: null,
        department_id: null,
        d_id: null,
        employeementSelectedType: "Contract",
        is_internet_handling_fee_applied: "N",
        is_direct_payment_allowed: "N",
      },
      selected: selected,
      isDisabled: null,

      flag: {
        isDistributor: false,
      },

      Distributors: [],

      //
      Genres: [],
      GenresMethod: {
        GET: "/admin/",
        tableName: "ms_genre",
        urlKey: "genres",
      },
      Gender: [],
      GenderMethod: {
        GET: "/admin/",
        tableName: "ms_gender",
        urlKey: "gender",
      },
      Countries: [],
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries",
      },

      States: [],
      StatesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_states",
        urlKey: "states",
      },

      Cities: [],
      CitiesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_cities",
        urlKey: "cities",
      },

      Roles: [],
      RolesMethod: {
        GET: "/admin/",
        tableName: "ms_roles",
        urlKey: "roles",
      },

      Designations: [],
      DesignationsMethods: {
        GET: "/admin/",
        tableName: "ms_designations",
        urlKey: "designations",
      },
      Cinemas: [],
      CinemasMethods: {
        GET: "/admin/",
        tableName: "ms_cinemas",
        urlKey: "cinemas",
      },
      Departments: [],
      DepartmentsMethods: {
        GET: "/admin/",
        tableName: "ms_departments",
        urlKey: "departments",
      },
      futuredate: "",
      previousdate: "",
      searchCountry: "",
      CountriesCopy: [],
      searchState: "",
      StatesCopy: [],
      searchCity: "",
      CitiesCopy: [],
      searchCode: "",
      CodeListCopy: [],
      countryList: [],
      SelectedCountryCode: "",
      sectionCollapse: {
        personalDetails: true,
      },
    };
  },
  beforeMount() {
    const { role_id, cinema_id } = this.secureStore.get("USINFO");
    this.loginRoleId = role_id;
    this.loginCinema_Id = cinema_id;
    this.getCountriesList();
    let roleid = role_id;
    let obj = cinema_id;

    /////////////////////////////////////////////////////
    this.futuredate = new Date();
    this.previousdate = new Date();
    this.previousdate.setFullYear(this.previousdate.getFullYear() - 50);
    // console.log("previousdate :", previousdate);
    this.futuredate.setDate(this.futuredate.getDate() + 7);
    this.onResetForm();
  },
  mounted() {
    const { userid } = this.$route;
  },
  computed: {
    showKitchenOrderFields() {
      return this.authorizeClient(CLIENT_NAMES_OBJ.show_color_for_aggregators)
    }
  },
  methods: {
    onSearchCode() {
      if (this.searchCode && this.searchCode.length > 0) {
        this.countryList = this.CodeListCopy.filter((x) => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.countryList = this.CodeListCopy;
      }
    },
    onSearchCountry: function (value) {
      console.log("Main.js");
      if (this.searchCountry && this.searchCountry.length > 0) {
        console.log("Hello", this.searchCountry);
        this.Countries = this.CountriesCopy.filter((x) => {
          if (
            x.country_name
              .toLowerCase()
              .includes(this.searchCountry.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Countries = this.CountriesCopy;
      }
    },
    onSearchState: function (value) {
      if (this.searchState && this.searchState.length > 0) {
        this.States = this.StatesCopy.filter((x) => {
          if (
            x.state_name.toLowerCase().includes(this.searchState.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.States = this.StatesCopy;
      }
    },
    onSearchCity: function (value) {
      if (this.searchCity && this.searchCity.length > 0) {
        this.Cities = this.CitiesCopy.filter((x) => {
          if (
            x.city_name.toLowerCase().includes(this.searchCity.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cities = this.CitiesCopy;
      }
    },
    onSelectEmployeementTypeHandler: function (value) {
      this.userDetails.employeementSelectedType = value;
    },
    onResetForm: function () {
      this.userDetails = {
        username: "",
        user_profile_image_url: "",
        first_name: "",
        aggregator_type: "",
        middle_name: "",
        last_name: "",
        email_id: "",
        mobile_no: "",
        cinema_id: 0,
        role_id: 10,
        password: "",
        zipcode: "",
        report_code: "",
        gl_account: "",
        gl_desc: "",
        kitchen_order_seq: "",
        kitchen_color_code: "#0e4e91",
        //userprofileData
        up_employee_code: "",
        up_dob: new Date("1990-01-01"),
        up_doj: "",
        up_address1: "",
        up_alt_contact_no: "",
        // dropdown ids
        designation_id: null,
        gender_id: null,
        city_id: null,
        state_id: null,
        country_id: null,
        department_id: null,
        d_id: null,

        employeementSelectedType: "Contract",
        is_internet_handling_fee_applied: "N",
        is_direct_payment_allowed: "N",
      };
      this.selected = {
        Country: "",
        Gender: "",
        Departments: "",
        Cinemas: "",
        Role: "",
        State: "",
        City: "",
        Designation: "",
        Distributor: "",
        employeementSelectedType: "Contract",
        AggregatorType: "",
      };
      // console.log("this.selected 1:", this.selected);
    },
    clearSelectedDate: function () {
      this.userDetails.up_dob = new Date("1990-01-01");
    },
    cleardoj: function () {
      this.userDetails.up_doj = "";
    },
    onSelectHandler: function (type, value) {
      if (type == "aggregatorType") {
        this.selected.AggregatorType = value;
        this.userDetails.aggregator_type = value;
      } else if (type == "gender") {
        this.selected.Gender = value.gender;
        this.userDetails.gender_id = value.gender_id;
      } else if (type == "country") {
        this.selected.Country = value.country_name;
        this.userDetails.country_id = value.country_id;
        this.userDetails.country_mob_code = value.country_mob_code;
        this.selected.State = null;
        this.selected.City = null;
        this.getStatesList(value.country_id);
      } else if (type == "state") {
        this.selected.State = value.state_name;
        this.userDetails.state_id = value.state_id;
        this.selected.City = null;
        this.getCitiesList(value.state_id);
      } else if (type == "city") {
        this.selected.City = value.city_name;
        this.userDetails.city_id = value.city_id;
      } else if (type == "role") {
        this.flag.isDistributor = false;
        this.loginRoleId = null;

        console.log("value.role_name :", value.role_name);
        this.selected.Role = value.role_name;
        this.userDetails.role_id = value.role_id;
        value.role_id === 9 ? (this.loginRoleId = 3) : "";
        if (value.role_id === 2) {
          value.role_id === 2 ? (this.loginRoleId = 3) : "";
          this.userDetails.cinema_id = 0;
        } else if (value.role_id === 9) {
          this.flag.isDistributor = true;
        }
      } else if (type == "designation") {
        this.selected.Designation = value.designation;
        this.userDetails.designation_id = value.designation_id;
      } else if (type == "cinema") {
        this.selected.Cinemas = value.cine_name;
        this.userDetails.cinema_id = value.cine_id;
        // console.log("this.userDetails.cinema_id :", this.userDetails.cinema_id);
      } else if (type == "department") {
        this.selected.Departments = value.dept_name;
        this.userDetails.department_id = value.dept_id;
      } else if (type == "distributor") {
        this.userDetails.d_id = value.d_id;
        this.selected.Distributor = value.d_company_name;
      } else if (type == "countrycode") {
        this.userDetails.country_mob_code = value.country_mob_code;
        this.SelectedCountryCode = value.country_mob_code;
      }

      this.$nextTick(() => {
        this.$validator.reset();
        this.$validator.errors.clear();
        this.$validator.resume();
        // console.log("object R :");
        this.$forceUpdate();
      });
    },
    getCountriesList: function () {
      this.Countries = [];
      let payload = {
        tableName: "ms_countries",
        country_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Countries = data.Records;
            this.CountriesCopy = data.Records;
            this.CodeListCopy = data.Records;
            this.countryList = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getStatesList: function (country_id) {
      let payload = {
        tableName: "ms_states",
        state_is_active: "Y",
        country_id: country_id,
      };
      MasterService.GetActiveList(payload)
        // this.States = [];
        // let body = this.getRequestBody("GET", undefined, {
        //   ...this.StatesMethod,
        //   params: { id: "country_id-" + country_id }
        // });
        // MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.States = data.Records;
            this.StatesCopy = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCountryHandler: function (country) {
      this.getStatesList(country.country_id);
    },
    onSelectStateHandler: function (state) {
      this.getCitiesList(state.state_id);
    },
    getCitiesList: function (state_id) {
      this.Cities = [];
      let payload = {
        tableName: "ms_cities",
        city_is_active: "Y",
        state_id: state_id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cities = data.Records;
            this.CitiesCopy = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onFinalSubmit: function (redirect) {
      this.submitted = true;

      console.log("...this.userDetails :", this.userDetails);
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.btenable = true;
          if (!this.userDetails.country_mob_code) {
            return;
          }
          UserService.AddUser({ ...this.userDetails, flag: this.flag })
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data.status) {
                console.log("resert call");
                this.onResetForm();
                if (redirect) {
                  // console.log("redirect value ",redirect);
                  this.$router.push({
                    path: "/user-management/aggregator-users",
                  });
                } else {
                  this.onResetForm();
                  this.submitted = false;
                  this.$toasted.show(data.error || data.message);
                }
              } else {
                this.$toasted.show(data.error || data.message);
              }
            })
            .catch(this._CatchError);
        } else {
          console.log("Valid Else :");
        }
      });
    },
    uploadImage: function (image) {
      // console.log("imagee",image);
      let self = this;
      let formData = new FormData();
      formData.append("image", image.target.files[0]);
      formData.append("imagePath", "/uploads/users/");
      MasterService.GlobalUploadImage(formData)
        .then((response) => {
          const { data } = response;
          data.message ? this.$toasted.show(data.message) : "";
          if (data.status) {
            self.userDetails.user_profile_image_url = data.path;
          }
          self.BaseURL = data.BaseURL;
        })
        .catch(this._CatchError);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/AggregatorsComponents/addAggregator.vue